import { atomWithStorage } from "jotai/utils";
import { createStore } from "jotai";

export type DebugOptions = {
  force_normal_worker: boolean;
  log_worker_messages: boolean;
  /** Print live-price trace stages to the console (see docs/live-prices-trace.md). */
  log_traces: boolean;
};

const DEFAULT_DEBUG_OPTIONS: DebugOptions = {
  force_normal_worker: false,
  log_worker_messages: false,
  log_traces: false,
};

export const readInitialDebugOptions = (): DebugOptions => {
  const debugOptions = localStorage.getItem("debug_options");
  try {
    return debugOptions
      ? { ...DEFAULT_DEBUG_OPTIONS, ...(JSON.parse(debugOptions) as DebugOptions) }
      : DEFAULT_DEBUG_OPTIONS;
  } catch {
    return DEFAULT_DEBUG_OPTIONS;
  }
};

export const debugOptionsAtom = atomWithStorage<DebugOptions>("debug_options", DEFAULT_DEBUG_OPTIONS);

export const debugAtomStore = createStore();
